"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  // eslint-disable-line
  list: {}
});

exports.default = _default;